import script from "./ProductArticlesMatrix.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductArticlesMatrix.vue?vue&type=script&setup=true&lang=ts"

import "./ProductArticlesMatrix.vue?vue&type=style&index=0&id=2fecefde&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fecefde"]])

export default __exports__